import { useQuery } from 'react-query';
import * as chartsApi from '../../lib/api/charts';

const identifier = 'charts';

export const useTop10Artists = () =>
  useQuery([identifier, 'top-10-artists'], () => chartsApi.getTop10Artists());
